// dependencies
import { CreateProcess } from "redux-process";

// utils
import get from "../../utils/GetNested";

export const getReviewReports = CreateProcess({
	method: "POST",
	name: "getReviewReports",
	type: "REVIEW_REPORTS:FETCH",

	request: (props) => {
		const payload = get(props, ["params", "payload"], props.payload);

		return {
			url: `/micro/v0.1/review-form-picker/by-name/`,
			payload,
		};
	},

	success: (response) => response.data,
});
